import { View, Image as PDFImage } from '@react-pdf/renderer';
import React from 'react';
import ImagenHorizontal from '../../../assets/img/jpg/imagen_horizontal.jpeg';
import ImageStyle from './Image.style';

function Image(props) {
  const {
    small = false,
    medium = true,
    big = false,
    bigger = false,
    source = null,
  } = props;
  const perStyles = {};

  if (small) perStyles.width = '150px';
  if (medium) perStyles.width = '200px';
  if (big) perStyles.width = '250px';
  if (bigger) perStyles.width = '300px';

  return (
    <View style={ImageStyle.container}>
      <PDFImage
        style={{ ...perStyles, ...ImageStyle.image }}
        source={source || ImagenHorizontal}
      />
    </View>
  );
}

export default Image;
